module.exports = __webpack_public_path__ + "static/media/vw-logo.ba550052.png";